//© 2026, Aptayo. All rights reserved
import React, { Component } from "react";
import Loader from "react-loader-spinner";
import { CSVLink } from "react-csv";
import CSVReader from "react-csv-reader";
import * as math from "mathjs";

import Refresh from "../../img/refresh.jpg";
import Select from "react-select";
import { animateScroll } from "react-scroll";

//This Block to ensure there aren't multiple tabs connected to the same device
let connected_device_name = "";
window.addEventListener("unload", () => {
  removeLSConnectedDevice();
});
const removeLSConnectedDevice = () => {
  let connectedDevices = JSON.parse(
    window.localStorage.getItem("zio_connected_devices")
  );
  connectedDevices = connectedDevices.filter(
    (element) => element !== connected_device_name
  );
  window.localStorage.setItem(
    "zio_connected_devices",
    JSON.stringify(connectedDevices)
  );
};
const checkDuplicateConnections = () => {
  let connectedDevices = JSON.parse(
    window.localStorage.getItem("zio_connected_devices")
  );
  if (
    connectedDevices &&
    connectedDevices.indexOf(connected_device_name) !== -1
  )
    alert(
      "Multiple Connections to Device detected! Be sure to have only one Google Chrome tab connected to the ZiO Device before running a test otherwise data will be lost"
    );
};
const localStoreConnectedDevice = () => {
  let connectedDevices = JSON.parse(
    window.localStorage.getItem("zio_connected_devices")
  );
  checkDuplicateConnections();
  if (connectedDevices) connectedDevices.push(connected_device_name);
  else connectedDevices = [connected_device_name];
  window.localStorage.setItem(
    "zio_connected_devices",
    JSON.stringify(connectedDevices)
  );
};
let current_service = null;
let outputHeadersAsStrings = [
  "Curve",
  "Device",
  "Length",
  "Electrode",
  "Frequency Hz",
  "Start_Voltage mV",
  "Range",
  "Peak_Current pA",
  "Peak_Current pA (Control)",
  "Peak_Current pA (Saturated)",
  "Error_Code",
  "SWVs",
  "Temperature",
];
let outputHeadersAsObjects = [];
let currentDevice = null;
let refreshGraph = false;
let packet_count_start = -2;
let packet_count = packet_count_start;
let meta_data = [];
let concentrationParameters = {};
let googleSheetID = "";
let baseCurrentMax = Infinity;
let control_metadata = [];
let sample_metadata = [];
let saturated_metadata = [];
let ranSaturatedTest = false;
let combined_meta_data = [];
let sample_ratios = {};
let control_ratios = {};
let saturated_ratios = {};
let dataBuffer = [];
let unshiftBuffer = null;
let unshiftAmount = null;
let max_render = 20; //Max number of cures to render
let render_data = [];
let output_data = [];
let curve_count = 0;
let new_message = "";
let current_curve_data = {};
let all_curve_data = [];
let automation_configs = [];
let test_count = 0;
let current_data_length = 0;
let current_curve_length = null;
let current_start_voltage = null;
let current_sweep_direction = null;
let test_state = "waiting";
let capturedMetaData = 0;
let metaDataLabels = [
  "Length",
  "Electrode",
  "Frequency Hz",
  "Start_Voltage mV",
  "Range",
  "Peak_Current pA",
  "Error_Code",
  "SWVs",
  "Temperature",
  "Noise Level",
  "Sweep Direction",
];
let previousPeak = null; //For concentration equation
let previousError = false; //For concentration equation
let previousFreq = null; //For ignoring dummy data
let dontPushMetaData = false;
const API_BASE = "https://7sdrpdiusa.execute-api.us-east-1.amazonaws.com/dev";

const csvCellValue = (value) => {
  if (value === undefined || value === null || value === "") {
    return "";
  }

  const stringValue = String(value).replace(/"/g, '""');
  return `"${stringValue}"`;
};

const convertToCSV = (rows, headers) => {
  if (!Array.isArray(rows) || !Array.isArray(headers) || headers.length === 0) {
    return "";
  }

  const csvRows = [headers.join(",")];

  rows.forEach((row) => {
    const values = headers.map((header) => {
      const value = row && Object.prototype.hasOwnProperty.call(row, header)
        ? row[header]
        : "";
      return csvCellValue(value);
    });
    csvRows.push(values.join(","));
  });

  return csvRows.join("\n");
};

async function saveCSVToCloud(fileName, csvContent) {
  const response = await fetch(`${API_BASE}/ylab-saveCSV`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ fileName, content: csvContent }),
  });

  return response.json();
}

async function listCSVFiles() {
  const response = await fetch(`${API_BASE}/ylab-readCSV`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({}),
  });

  return response.json();
}

async function getCSVContent(fileName) {
  const response = await fetch(`${API_BASE}/ylab-readCSV`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ fileName }),
  });

  return response.json();
}

let concentrationEquationOptions = [
  { value: 1, label: "Linear" },
  { value: 2, label: "Hyperbolic" },
  { value: 3, label: "Exponential" },
];
let sweepDirectionOptions = [
  { value: 0, label: "Low to High" },
  { value: 1, label: "High to Low" },
];
let data_count = 0;
let last_written_data = {};
let db = null;

if (!("indexedDB" in window)) {
  console.log("This browser doesn't support IndexedDB");
}

class SettingsMenu extends Component {
  constructor(props) {
    console.log("Build Version 0.91");
    super(props);
    this.state = {
      finalFinalConcentration: 0,
      firstRunOfAutomation: true,
      debug: false,
      show_error: false,
      error_message: "",
      preparing_save: false,
      save_ready: false,
      status_message: "",
      user_disconnected: false,
      battery_level: 100,
      loading_file: false,
      automated_test: false,
      characteristics_menu_open: false,
      loading: false,
      device_name: null,
      device_paired: null,
      current_service: null,
      menu_open: false,
      running_test: false,
      cart_detect: 0,
      frequency_NR: 180,
      frequency: 400,
      start_voltage: -300,
      range: 7,
      range_NR: 7,
      we_selected: 1,
      SWV: 3,
      selectedEquation: concentrationEquationOptions[0],
      A: 0,
      B: 0,
      N: 0,
      concentration_avg_filter: 0,
      selectedSweepDirection: sweepDirectionOptions[0],
      selectCalibrated: "",
    };
  }

  componentDidMount = () => {
    //setInterval( this.updateBattery, 20000);
  };

  flushMemory = () => {
    meta_data = [];
    dataBuffer = [];
    render_data = [];
    output_data = [];
    curve_count = 0;
    new_message = "";
    current_curve_data = {};
    all_curve_data = [];
    automation_configs = [];
    test_count = 0;
    current_curve_length = null;
    current_start_voltage = null;
    test_state = "waiting";
    capturedMetaData = 0;
    let objectStore = db
      .transaction(["dataBuffer"], "readwrite")
      .objectStore("dataBuffer");
    let req = objectStore.clear();
    let objectStore2 = db
      .transaction(["renderData"], "readwrite")
      .objectStore("renderData");
    req = objectStore.clear();
    this.props.updateGraphMethod([], []);
    this.setState({ status_message: "" });
  };

  exportedData = () => {
    this.setState({ show_error: false });
  };

  saveMetaData = () => {
    if (this.state.automated_test)
      current_curve_data["automated_row_number"] = automation_configs[0].Order;
    new_message = new_message + "\n \n";
    Object.keys(current_curve_data).map((el) => {
      new_message = new_message + "\n " + el + ": " + current_curve_data[el];
    });
    current_sweep_direction = parseInt(current_curve_data["Sweep Direction"]);
    // If sweep direction is high to low, start voltage is - 500
    current_start_voltage =
      current_sweep_direction === 1
        ? parseInt(current_curve_data["Start_Voltage mV"]) - 500
        : parseInt(current_curve_data["Start_Voltage mV"]);
    this.setState({ status_message: new_message });
    setTimeout(() => {
      animateScroll.scrollToBottom({
        containerId: "status-message",
      });
    }, 500);
  };

  shouldDeleteDummyData = () => {
    //When Freq === FreqNR this indicates dummy data and metadata should be deleted
    if (previousFreq === current_curve_data["Frequency Hz"]) {
      dontPushMetaData = true;
      return true;
    }
    return false;
  };

  //This method is triggered every time a bluetooth notification is recieved on the device
  handleCharacteristicValueChanged = async (event) => {
    let peakCurrentLabel = "Peak_Current pA";
    if (this.currentlyRunningControlTest()) {
      peakCurrentLabel = "Peak_Current pA (Control)";
    } else if (sample_metadata.length > 0) {
      peakCurrentLabel = "Peak_Current pA (Saturated)";
    }
    let dv = event.target.value;
    let incomingPackets = [
      dv.getInt32(0, true),
      dv.getInt32(4, true),
      dv.getInt32(8, true),
      dv.getInt32(12, true),
      dv.getInt32(16, true),
    ];
    if (this.state.debug) console.log("Raw data packet", incomingPackets);
    while (incomingPackets.length > 0) {
      let currentDataVal = incomingPackets[0];
      if (currentDataVal === -1431655766) {
        test_state = "metadata";
        this.setState({ loading: true });
      } else if (currentDataVal === -572662307) {
        test_state = "testdata";
        capturedMetaData = 0;
        current_data_length = 0;
        this.saveMetaData();
      } else if (currentDataVal === 1431655765) {
        test_state = "waiting";
        if (!dontPushMetaData) {
          meta_data.push(current_curve_data);
        } else {
          meta_data.pop();
          dontPushMetaData = false;
          previousFreq = null;
        }
        if (curve_count % 2 !== 0) {
          if (current_sweep_direction === 1)
            this.updateGraph(
              current_curve_data["Start_Voltage mV"] - 1,
              curve_count
            );
          else
            this.updateGraph(
              current_data_length -
                Math.abs(current_curve_data["Start_Voltage mV"]) -
                1,
              curve_count
            );
          // this.show_filtered_concentration();
        }
        curve_count++;
        current_curve_data = {};
        data_count = 0;
        test_count--;
      } else if (test_state === "metadata") {
        if (capturedMetaData >= metaDataLabels.length) {
          console.log(
            "Extra meta data values found but there are not enough labels defined"
          );
        } else {
          if (capturedMetaData === 0) {
            current_curve_data["Curve"] = "y" + curve_count + " ADC";
            current_curve_data["Device"] = this.state.device_name;
          }
          // This is where metadata is stored in current_curve_data
          current_curve_data[metaDataLabels[capturedMetaData]] = currentDataVal;
          //Store freq peak so concentration can be calculated for freqNR
          if (
            capturedMetaData + 1 == metaDataLabels.length &&
            previousPeak != null
          ) {
            //Only store data if not dummy
            if (!this.shouldDeleteDummyData()) {
              current_curve_data[
                "Equation"
              ] = this.state.selectedEquation.label;
              previousPeak = null;
              previousFreq = null;
              previousError = false;
            }
          } else if (
            !previousPeak &&
            capturedMetaData + 1 == metaDataLabels.length
          ) {
            if (!this.shouldDeleteDummyData()) {
              if (current_curve_data["Error_Code"] != 0) previousError = true;
              else previousPeak = current_curve_data[peakCurrentLabel];
              previousFreq = current_curve_data["Frequency Hz"];
            }
          }
          capturedMetaData++;
        }
      } else if (test_state === "testdata") {
        current_data_length++;
        if (data_count < 10 && currentDataVal > baseCurrentMax) {
          this.setState({
            show_error: true,
            error_message:
              "Base current" +
              currentDataVal +
              " is too high. (>" +
              baseCurrentMax +
              ") \n Change the cartridge/chip.",
          });
        }
        this.storeDataBuffer(
          {
            x: current_start_voltage + data_count,
            ["y" + curve_count + " ADC"]: currentDataVal,
          },
          curve_count
        );
        data_count++;
      }
      incomingPackets.shift();
    }
  };

  /*  I think the curveCount is passed into this
      (as aposed to global variable: curve_count)
      function because we are limiting it to only
      the curves we have the data for.
  */
  updateGraph = (expected_length, curveCount) => {
    let curves = [];
    // This if ensure all data points are written to indexedDB before rendering to graph
    if (last_written_data[curveCount] >= expected_length) {
      if (curveCount + 1 <= max_render) {
        for (let i = 0; i <= curveCount; i++) {
          curves.push(i);
        }
        let objectStore = db
          .transaction(["dataBuffer"], "readwrite")
          .objectStore("dataBuffer");
        let req2 = objectStore.getAll();
        req2.onerror = (e) => {
          console.log(e);
        };
        req2.onsuccess = (e) => {
          if (this.state.debug) console.log(e.target.result);
          this.props.updateGraphMethod(e.target.result, curves);
          this.setState({ loading: false });
          if (this.state.automated_test) {
            console.log(
              "Automated row order number: " +
                automation_configs[0].Order +
                " " +
                (test_count % 2 == 0 ? "" : "(NR)")
            );
            if (test_count == 0) {
              //If both tests were run and were still doing automated testing go onto the next row;
              automation_configs.shift();
              this.run_automated_tests(automation_configs);
            }
          }
        };
      } else {
        let firstCurve = curveCount - max_render + 1;
        for (let i = firstCurve; i <= curveCount; i++) {
          curves.push(i);
        }
        let objectStore = db
          .transaction(["renderData"], "readwrite")
          .objectStore("renderData");
        let req2 = objectStore.getAll();
        req2.onerror = (e) => {
          console.log(e);
        };
        req2.onsuccess = (e) => {
          if (this.state.debug) console.log(e.target.result);
          this.props.updateGraphMethod(e.target.result, curves);
          this.setState({ loading: false });
          if (this.state.automated_test) {
            console.log(
              "Automated row order number: " +
                automation_configs[0].Order +
                " " +
                (test_count % 2 == 0 ? "" : "(NR)")
            );
            if (test_count == 0) {
              //If both tests were run and were still doing automated testing go onto the next row;
              automation_configs.shift();
              this.run_automated_tests(automation_configs);
            }
          }
        };
      }
    } else {
      setTimeout((e) => {
        this.updateGraph(expected_length, curveCount);
      }, 1000);
    }
  };

  storeDataBuffer = (obj, curveCount) => {
    let objectStore = db
      .transaction(["dataBuffer"], "readwrite")
      .objectStore("dataBuffer");
    let getReq = objectStore.get(data_count + current_start_voltage);
    getReq.onerror = async (e) => {
      console.log("error ");
      return;
    };

    getReq.onsuccess = async (e) => {
      let dataToAdd = obj;
      if (e.target.result) {
        //Combine new and old
        dataToAdd = { ...obj, ...e.target.result };
      }
      let dataBufferTransaction = db.transaction(["dataBuffer"], "readwrite");
      let objectStore = dataBufferTransaction.objectStore("dataBuffer");
      let requestUpdate = objectStore.put(dataToAdd);
      requestUpdate.addEventListener("error", (event) => {
        console.log("Request error:", requestUpdate.error);
      });
      requestUpdate.onerror = function(event) {
        console.log("error storing data in indexedDB");
        return;
      };
      requestUpdate.onsuccess = function(event) {
        if (curveCount + 1 === max_render && obj.x == current_start_voltage) {
          //console.log("maxRender reached", curveCount, max_render);
          let req2 = objectStore.getAll();
          req2.onerror = (e) => {
            console.log(e);
          };
          req2.onsuccess = (e) => {
            let renderDataStore = db
              .transaction(["renderData"], "readwrite")
              .objectStore("renderData");
            e.target.result.forEach((value) => {
              renderDataStore.put(value);
            });
          };
        } else if (curveCount + 1 > max_render) {
          //console.log("maxRender exceeded", curveCount, max_render);
          let renderDataStore = db
            .transaction(["renderData"], "readwrite")
            .objectStore("renderData");
          //First curve to delete
          let firstCurve = curveCount - max_render - 1;
          if (obj.x == current_start_voltage && curveCount % 2 == 0) {
            //curve_count % 2 is to make sure this is only done once for each pair
            let req2 = renderDataStore.getAll();
            requestUpdate.addEventListener("error", (event) => {
              console.log("Request error:", requestUpdate.error);
            });
            req2.onerror = (e) => {
              console.log(e);
            };
            req2.onsuccess = (e) => {
              e.target.result.forEach((value) => {
                delete value["y" + firstCurve + " ADC"];
                delete value["y" + (firstCurve + 1) + " ADC"];
                if (Object.keys(value).length <= 1)
                  renderDataStore.delete(value.x);
                else renderDataStore.put(value);
              });
            };
          }
          delete dataToAdd["y" + firstCurve + " ADC"];
          delete dataToAdd["y" + (firstCurve + 1) + " ADC"];
          let requestUpdate2 = renderDataStore.put(dataToAdd);
          requestUpdate.onerror = function(event) {
            console.log("error storing data in indexedDB");
            return;
          };
        }
        //return;
      };
      dataBufferTransaction.oncomplete = () => {
        if (
          last_written_data[curveCount] &&
          obj.x != last_written_data[curveCount] + 1
        )
          console.log(
            "MISSED DATA AT CURVE",
            curveCount,
            obj.x,
            last_written_data[curveCount]
          );
        last_written_data[curveCount] = obj.x;
      };
      dataBufferTransaction.onabort = () => {
        console.log(
          "TRANSACTION ABORTED CURVE",
          curveCount,
          dataBufferTransaction.error
        );
      };
    };
  };

  pairDevice = async () => {
    let pairedDevice = null;
    try {
      console.log("Trying to pair...");
      let current_service = null;
      //Below is a request that uses a filter, so no irrelevant bluetooth devices are shown
      //navigator.bluetooth.requestDevice({filters: [{name: 'Potentiostat'}], optionalServices: ['16d30bc1-f148-49bd-b127-8042df63ded0']})
      let pairedDevice = await navigator.bluetooth.requestDevice({
        filters: [{ namePrefix: "ZIO" }],
        optionalServices: [
          "16d30bc1-f148-49bd-b127-8042df63ded0",
          "0000180a-0000-1000-8000-00805f9b34fb",
        ],
      });
      let device = pairedDevice;
      connected_device_name = device.name;
      localStoreConnectedDevice();
      this.setState({ loading: true });
      pairedDevice.addEventListener(
        "gattserverdisconnected",
        this.onDisconnected
      );
      // if (this.state.debug)
      // console.log("pairedDevice", JSON.stringify(pairedDevice), pairedDevice, device);
      // Attempts to connect to remote GATT Server.
      let server = await device.gatt.connect();
      console.log("server", JSON.stringify(server));
      let service = await server.getPrimaryService(
        "16d30bc1-f148-49bd-b127-8042df63ded0"
      );
      let infoService = await server.getPrimaryService(
        "0000180a-0000-1000-8000-00805f9b34fb"
      );
      let enc = new TextDecoder("utf-8");
      let firmwareCharacteristic = await infoService.getCharacteristic(
        "00002a26-0000-1000-8000-00805f9b34fb"
      );
      let firmwareValue = await firmwareCharacteristic.readValue();
      let firmwareString = enc.decode(firmwareValue);
      console.log("service", JSON.stringify(service));
      let request = window.indexedDB.open(pairedDevice.id, 2);
      request.onerror = function(event) {
        console.log("Error loading IndexedDB, code:", event.target.errorCode);
      };
      request.onsuccess = function(event) {
        db = event.target.result;
        let objectStore = db
          .transaction(["dataBuffer"], "readwrite")
          .objectStore("dataBuffer");
        objectStore.clear();
        let req2 = objectStore.getAll();
        req2.onerror = (e) => {
          console.log(e);
        };
        req2.onsuccess = (e) => {
          console.log("IndexedDB connected.");
        };

        let objectStore2 = db
          .transaction(["renderData"], "readwrite")
          .objectStore("renderData");
        objectStore2.clear();
      };
      request.onupgradeneeded = function(event) {
        db = event.target.result;
        var objectStore = db.createObjectStore("dataBuffer", { keyPath: "x" });
        var objectStore = db.createObjectStore("renderData", { keyPath: "x" });
      };
      this.setState({
        loading: false,
        device_name: pairedDevice.name,
        device_paired: pairedDevice,
        current_service: service,
        firmware: firmwareString,
        show_error: false,
      });
      this.updateBattery();
    } catch (error) {
      console.error("Pairing failed", error);
      this.setState({
        loading: false,
        user_disconnected: true,
        device_name: null,
        device_paired: null,
        current_service: null,
      });
      if (pairedDevice) pairedDevice.gatt.disconnect();
    }
  };

  disconnectDevice = () => {
    if (this.state.device_paired) {
      this.state.device_paired.gatt.disconnect();
      removeLSConnectedDevice();
      this.setState({
        user_disconnected: true,
        device_name: null,
        device_paired: null,
        current_service: null,
      });
    }
  };

  onDisconnected = (e) => {
    console.log("> Bluetooth Device disconnected");
    try {
      this.state.device_paired.gatt.disconnect();
    } catch (e) {
      console.error(e);
    }
    if (!this.state.user_disconnected) {
      removeLSConnectedDevice();
      this.setState({ show_error: true, error_message: "Device Disconnected" });
      this.reconnectDevice();
    }
  };

  logTime = (text) => {
    console.log("[" + new Date().toJSON().substr(11, 8) + "] " + text);
  };

  re_run_automated_tests = () => {
    if (this.state.automated_test) {
      let i;
      for (i = meta_data.length - 1; i >= 0; i--) {
        if (
          meta_data[i]["Automated_Row_Number"] == automation_configs[0].Order
        ) {
          curve_count--;
        } else {
          break;
        }
      }
      console.log("DONE", curve_count);
      this.run_automated_tests(automation_configs);
      return;
    }
  };

  runSaturatedTest = () => {
    this.prepare_save_sample();
    ranSaturatedTest = true;
    this.setState({
      controlFileUploaded: undefined,
      firstRunOfAutomation: true,
      calculateControlRatio: true,
      show_error: false,
      error_message: "",
    });
    metaDataLabels[metaDataLabels.indexOf("Peak_Current pA")] =
      "Peak_Current pA (Saturated)";
    this.start_run_test();
  };

  continueSampleTest = () => {
    this.setState({
      controlFileUploaded: undefined,
      firstRunOfAutomation: true,
      calculateControlRatio: true,
      show_error: false,
      error_message: "",
    });
    metaDataLabels[metaDataLabels.indexOf("Peak_Current pA (Control)")] =
      "Peak_Current pA";
    this.start_run_test();
  };

  reconnectDevice = () => {
    if (!this.state.device_paired) return;
    this.exponentialBackoff(
      15 /* max retries */,
      2 /* seconds delay */,
      () => {
        //toTry()
        this.logTime("Reconnecting to Bluetooth Device... ");
        return this.state.device_paired.gatt.connect();
      },
      (server) => {
        //success()
        if (this.state.debug) console.log("server", server);
        server
          .getPrimaryService("16d30bc1-f148-49bd-b127-8042df63ded0")
          .then((service) => {
            this.setState({ current_service: service, show_error: false });
            console.log("> Bluetooth Device connected. Reconnected");
            this.re_run_automated_tests();
          })
          .catch((error) => {
            console.log("Reconnect to Service", error);
            this.reconnectDevice(); //Try again
          });
      },
      () => {
        //fail()
        this.logTime("Failed to reconnect.");
      }
    );
  };

  // This function keeps calling "toTry" until promise resolves or has
  // retried "max" number of times. First retry has a delay of "delay" seconds.
  // "success" is called upon success.
  exponentialBackoff = (max, delay, toTry, success, fail) => {
    toTry()
      .then((result) => success(result))
      .catch((e) => {
        if (max === 0) {
          return fail();
        }
        console.error(e);
        this.logTime("Retrying in " + delay + "s... (" + max + " tries left)");
        setTimeout(() => {
          this.exponentialBackoff(--max, delay * 2, toTry, success, fail);
        }, delay * 1000);
      });
  };

  updateCharacteristics = async (run_test_after) => {
    this.setState({ menu_open: false, loading: true });
    // Dataview needs to be made to make a big endian ArrayBuffer

    let buffer = null;
    let dv = null;
    let SWV_enabled = true;

    try {
      buffer = new ArrayBuffer(1);
      dv = new DataView(buffer);
      dv.setUint8(0, parseInt(this.state.SWV), false);
      let SWV_characteristic = await this.state.current_service.getCharacteristic(
        "16d30bce-f148-49bd-b127-8042df63ded0"
      );

      if (this.state.SWV < 0) {
        alert("SWV characteristic must be greater than 0");
        return;
      }
      SWV_characteristic.writeValue(dv.buffer);
    } catch (e) {
      SWV_enabled = false;
      console.log(e, ": error updating SWV");
    }

    // Write to BLE_UUID_ZIO_FREQ1_CHAR
    buffer = new ArrayBuffer(2);
    dv = new DataView(buffer);
    dv.setUint16(0, parseInt(this.state.frequency), false);
    let freq1_characteristic = await this.state.current_service.getCharacteristic(
      "16d30bc2-f148-49bd-b127-8042df63ded0"
    );
    freq1_characteristic.writeValue(dv.buffer);

    // Write to BLE_UUID_ZIO_FREQNR_CHAR
    buffer = new ArrayBuffer(2);
    dv = new DataView(buffer);
    dv.setUint16(0, parseInt(this.state.frequency_NR), false);
    let freqNR_characteristic = await this.state.current_service.getCharacteristic(
      "16d30bc3-f148-49bd-b127-8042df63ded0"
    );
    freqNR_characteristic.writeValue(dv.buffer);

    // Write to BLE_UUID_ZIO_START_VOLT_CHAR
    buffer = new ArrayBuffer(2);
    dv = new DataView(buffer);
    dv.setInt16(0, parseInt(this.state.start_voltage), false);
    let startV_characteristic = await this.state.current_service.getCharacteristic(
      "16d30bc4-f148-49bd-b127-8042df63ded0"
    );
    startV_characteristic.writeValue(dv.buffer);

    // Write to BLE_UUID_ZIO_RANGE1_CHAR
    buffer = new ArrayBuffer(1);
    dv = new DataView(buffer);
    dv.setUint8(0, parseInt(this.state.range), false);
    let range1_characteristic = await this.state.current_service.getCharacteristic(
      "16d30bc6-f148-49bd-b127-8042df63ded0"
    );
    range1_characteristic.writeValue(dv.buffer);

    // Write to BLE_UUID_ZIO_RANGENR_CHAR
    buffer = new ArrayBuffer(1);
    dv = new DataView(buffer);
    dv.setUint8(0, parseInt(this.state.range_NR), false);
    let rangeNR_characteristic = await this.state.current_service.getCharacteristic(
      "16d30bc7-f148-49bd-b127-8042df63ded0"
    );
    rangeNR_characteristic.writeValue(dv.buffer);

    // Write to BLE_UUID_WE_SELECT
    buffer = new ArrayBuffer(4);
    dv = new DataView(buffer);
    dv.setUint32(0, parseInt(this.state.we_selected), false);
    let WE_characteristic = await this.state.current_service.getCharacteristic(
      "16d30bcb-f148-49bd-b127-8042df63ded0"
    );
    WE_characteristic.writeValue(dv.buffer);

    // Write to sweep direction characteristic
    buffer = new ArrayBuffer(1);
    dv = new DataView(buffer);
    if (this.state.selectedSweepDirection)
      dv.setUint8(0, parseInt(this.state.selectedSweepDirection.value), false);
    let sweepDirection_characteristic = await this.state.current_service.getCharacteristic(
      "16d30bd2-f148-49bd-b127-8042df63ded0"
    );
    sweepDirection_characteristic.writeValue(dv.buffer);

    let message =
      "\n \n Characteristics updated: \n Frequency1: " +
      this.state.frequency +
      "\n Frequency2: " +
      this.state.frequency_NR +
      "\n Start Voltage: " +
      this.state.start_voltage +
      "\n Range1: " +
      this.state.range +
      "\n RangeNR: " +
      this.state.range_NR +
      "\n WE Selected: " +
      this.state.we_selected +
      "\n Sweep Direction: " +
      this.state.selectedSweepDirection.label;

    if (SWV_enabled) message = message + "\n SWV: " + this.state.SWV;
    this.setState({
      status_message: this.state.status_message + message,
      loading: false,
    });
    setTimeout(() => {
      animateScroll.scrollToBottom({
        containerId: "status-message",
      });
    }, 500);

    if (run_test_after) this.runTest();
  };

  runTest = () => {
    console.log("Attempting to run tests...");

    test_count = ((this.state.we_selected + "").split("1").length - 1) * 2;

    //Cartridge detect
    this.state.current_service
      .getCharacteristic("16d30bc5-f148-49bd-b127-8042df63ded0")
      .then((characteristic) => {
        characteristic.readValue().then((value) => {
          //if there is no cartridge detected value.getInt8 should == 0
          if (value.getInt8() == 0) {
            //if (false) { // Debuging without cartridge
            console.log("No cartridge detected");
            alert("No cartridge detected");
            return;
          } else {
            packet_count = packet_count_start;

            if (
              this.state.controlFileUploaded &&
              this.state.runningControlTest
            ) {
              metaDataLabels[metaDataLabels.indexOf("Peak_Current pA")] =
                "Peak_Current pA (Control)";
            } else if (sample_metadata.length > 0) {
              metaDataLabels[metaDataLabels.indexOf("Peak_Current pA")] =
                "Peak_Current pA (Saturated)";
            }

            //Listen to Data characteristic
            this.state.current_service
              .getCharacteristic("16d30bc9-f148-49bd-b127-8042df63ded0")
              .then((characteristic) => {
                characteristic.startNotifications();
                return characteristic;
              })
              .then((characteristic) => {
                characteristic.addEventListener(
                  "characteristicvaluechanged",
                  this.handleCharacteristicValueChanged
                );
              })
              .then((_) => {
                //Write 1 to CMD characteristic to start test
                this.state.current_service
                  .getCharacteristic("16d30bc8-f148-49bd-b127-8042df63ded0")
                  .then((CMDCharacteristic) => {
                    console.log("running Tests");
                    CMDCharacteristic.writeValue(Uint8Array.of(1));
                  })
                  .catch((error) => {
                    console.log(error);
                  });
                this.setState({ loading: true });
              })
              .catch((error) => {
                console.log(error);
              });
          }
        });
      })
      .catch((error) => {
        console.log("Cartridge-Detect Characteristic Read", error);
      });
  };

  toggleMenuOpen = () => {
    this.setState({
      show_error: false,
      menu_open: !this.state.menu_open,
      characteristics_menu_open: false,
      loading_file: false,
      save_ready: false,
    });
  };

  open_characteristics_menu = () => {
    this.setState({ characteristics_menu_open: true });
  };

  handleInputParameterChange = (e) => {
    if (this.state.debug)
      console.log("target, name:", e.target.value, e.target.name);

    if (e.target.value == "on" || e.target.value == "off") {
      this.setState({ [e.target.name]: !this.state[e.target.name] });
      return;
    }

    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  stop_automated_test = () => {
    this.setState({ automated_test: false, menu_open: false });
    console.log("Stopping automated test (not running next row)..");
  };

  open_loading_file = () => {
    this.setState({ loading_file: true });
  };

  removeOutliers = (obj) => {
    // Convert object values to array
    const values = Object.values(obj);

    // Calculate mean
    const mean =
      values.reduce((total, value) => total + value, 0) / values.length;

    // Calculate standard deviation
    const sd = Math.sqrt(
      values.reduce((total, value) => total + Math.pow(value - mean, 2), 0) /
        values.length
    );

    // Filter out values more than 2 standard deviations from the mean
    const result = Object.keys(obj)
      .filter((key) => Math.abs(obj[key] - mean) <= 2 * sd)
      .reduce((result, key) => {
        result[key] = obj[key];
        return result;
      }, {});

    console.log("removed outliers");
    console.log(JSON.stringify(obj), "obj");
    console.log(JSON.stringify(result), "result");
    return result;
  };

  getPeakCurrentValue = (row) => {
    return row["Peak_Current pA"] !== undefined
      ? row["Peak_Current pA"]
      : row["Peak_Current pA (Control)"] !== undefined
      ? row["Peak_Current pA (Control)"]
      : row["Peak_Current pA (Saturated)"];
  };

  calculate_ratio_averages = (inputMetadata, label) => {
    // if there are 2 or less 0 peaks, remove them from calculation
    let zeroPeakCount = 0;
    const originalInputMetadata = [...inputMetadata];
    for (const i in inputMetadata) {
      const rowPeakCurrent = this.getPeakCurrentValue(inputMetadata[i]);
      if (rowPeakCurrent === 0) {
        zeroPeakCount++;
        console.log("deleting (zero peak) index", i, " of ", inputMetadata);
        delete inputMetadata[i];
      }
      if (zeroPeakCount > 2) {
        console.log("returning zero peaks as there are more than 2");
        inputMetadata = originalInputMetadata;
        break;
      }
    }
    //Build frequency and electrode dictionary for each curve
    let freq_electrode_arrays = {}; // {"freq_elec": [x1,x2 .. xn]}
    inputMetadata.forEach((row) => {
      //Ensure the right peak current is used for the row
      // essentially just used whichever is defined
      const rowPeakCurrent = this.getPeakCurrentValue(row);
      if (row["Frequency Hz"] + "_" + row.Electrode in freq_electrode_arrays) {
        freq_electrode_arrays[row["Frequency Hz"] + "_" + row.Electrode].push(
          rowPeakCurrent
        );
      } else {
        freq_electrode_arrays[row["Frequency Hz"] + "_" + row.Electrode] = [
          rowPeakCurrent,
        ];
      }
    });
    console.log(JSON.stringify(freq_electrode_arrays), "freq_electrode_arrays");
    let tempRatio = {};
    let ratios = {};
    let pairs = Object.keys(freq_electrode_arrays);
    pairs.forEach((currentPair) => {
      let avgPeak = math.mean(freq_electrode_arrays[currentPair]);
      let currentElectrode = label + "_Electrode_" + currentPair.split("_")[1];
      // calculate the ratio freqNR/freq for each electrode
      if (tempRatio[currentElectrode]) {
        // always bigger frequency as nominator and smaller freq and denominator
        if (
          parseInt(tempRatio[currentElectrode].freq) >
          parseInt(currentPair.split("_")[0])
        )
          ratios[currentElectrode] = tempRatio[currentElectrode].val / avgPeak;
        else
          ratios[currentElectrode] = avgPeak / tempRatio[currentElectrode].val;
      } else {
        tempRatio[currentElectrode] = {
          val: avgPeak,
          freq: currentPair.split("_")[0],
        };
      }
      console.log(currentPair, "currentPair");
      console.log(avgPeak, "avgPeak");
      console.log(currentElectrode, "currentElectrode");
      console.log(JSON.stringify(tempRatio), "tempRatio");
      console.log(JSON.stringify(ratios), "ratios");
    });
    console.log(JSON.stringify(ratios), "ratios");
    let ratio_sum = Object.values(ratios).reduce((a, b) => a + b, 0);
    let ratio_avg = ratio_sum / Object.values(ratios).length;
    ratios[label + "_Total_Average"] = ratio_avg;
    console.log(
      ratio_avg,
      "average ratio across all electrodes for ",
      label,
      " method"
    );
    return ratios;
  };

  prepare_save_control = () => {
    control_metadata = meta_data;
    combined_meta_data = control_metadata;
    meta_data = [];
    control_ratios = this.calculate_ratio_averages(control_metadata, "Control");
    control_ratios = this.removeOutliers(control_ratios);
    this.setState({
      controlFileUploaded: undefined,
      firstRunOfAutomation: true,
      calculateControlRatio: true,
      show_error: true,
      error_message:
        "Discard the buffer solution, add patient sample to the cartridge",
    });
  };

  prepare_save_saturated = () => {
    saturated_metadata = meta_data;
    combined_meta_data = combined_meta_data.concat(saturated_metadata);
    saturated_ratios = this.calculate_ratio_averages(
      saturated_metadata,
      "Saturated"
    );
    saturated_ratios = this.removeOutliers(saturated_ratios);
    console.log(JSON.stringify(saturated_ratios), "saturated_ratios");
  };

  prepare_save_sample = () => {
    sample_metadata = meta_data;
    combined_meta_data = combined_meta_data.concat(sample_metadata);
    meta_data = [];
    sample_ratios = this.calculate_ratio_averages(sample_metadata, "Sample");
    sample_ratios = this.removeOutliers(sample_ratios);
    console.log(JSON.stringify(sample_ratios), "sample_ratios");
  };
    
  prepare_emergency_save = () => {
    this.prepare_save_control();
    this.prepare_save_sample();
    this.prepare_save_saturated();
    this.prepare_export();
  }

  calculateHyperbolicConcentration = (R, A, B, N) => {
    try {
      return (R * A + B) / (N - R);
    } catch (e) {
      console.log("unable to calculate hyperbolic concentration", e);
      return "";
    }
  };

  calculateSigmoidalConcentration = (R, K0, S0, Smax, eN) => {
    try {
      return Math.pow(K0 * ((R - S0) / (Smax - R)), 1 / eN);
    } catch (e) {
      console.log("unable to calculate hyperbolic concentration", e);
      return "";
    }
  };

  calculateFinalConcentrations = (R1, R2, sample_ratio) => {
    console.log(concentrationParameters, "concentrationParameters");
    const finalConcentrations = {};
    finalConcentrations[
      "Concentration1"
    ] = this.calculateHyperbolicConcentration(
      sample_ratio,
      concentrationParameters["A1"],
      concentrationParameters["B1"],
      concentrationParameters["N1"]
    );
    finalConcentrations[
      "Concentration2"
    ] = this.calculateHyperbolicConcentration(
      R1,
      concentrationParameters["A2"],
      concentrationParameters["B2"],
      concentrationParameters["N2"]
    );
    finalConcentrations[
      "Concentration3"
    ] = this.calculateHyperbolicConcentration(
      R2,
      concentrationParameters["A3"],
      concentrationParameters["B3"],
      concentrationParameters["N3"]
    );
    finalConcentrations[
      "Concentration4"
    ] = this.calculateSigmoidalConcentration(
      sample_ratio,
      concentrationParameters["K01"],
      concentrationParameters["S01"],
      concentrationParameters["Smax1"],
      concentrationParameters["eN1"]
    );
    finalConcentrations[
      "Concentration5"
    ] = this.calculateSigmoidalConcentration(
      R1,
      concentrationParameters["K02"],
      concentrationParameters["S02"],
      concentrationParameters["Smax2"],
      concentrationParameters["eN2"]
    );
    finalConcentrations[
      "Concentration6"
    ] = this.calculateSigmoidalConcentration(
      R2,
      concentrationParameters["K03"],
      concentrationParameters["S03"],
      concentrationParameters["Smax3"],
      concentrationParameters["eN3"]
    );
    return finalConcentrations;
  };

  filterEmptyStrings = (obj) => {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      if (value) {
        acc[key] = value;
      }
      return acc;
    }, {});
  };

  averageObjectValues = (obj) => {
    const values = Object.values(obj);
    const sum = values.reduce((total, value) => total + value, 0);
    return sum / values.length;
  };

  prepare_export = () => {
    this.prepare_save_saturated();
    const combined_ratios = {
      ...control_ratios,
      ...sample_ratios,
      ...saturated_ratios,
    };
    console.log(JSON.stringify(combined_ratios), "combined_ratios");
    console.log(JSON.stringify(meta_data), "meta_data");
    Object.keys(combined_ratios).forEach((ratio_label) => {
      outputHeadersAsStrings.unshift(ratio_label);
    });
    for (let i = 0; i <= curve_count - 1; i++) {
      let headerString = "y" + i + " ADC";
      outputHeadersAsStrings.push(headerString);
    }
    const R1 =
      saturated_metadata.length > 0
        ? sample_ratios["Sample_Total_Average"] /
          saturated_ratios["Saturated_Total_Average"]
        : "";
    const R2 =
      control_metadata.length > 0
        ? sample_ratios["Sample_Total_Average"] /
          control_ratios["Control_Total_Average"]
        : "";
    console.log(R1, "R1");
    console.log(R2, "R2");
    let finalConcentrations = this.calculateFinalConcentrations(
      R1,
      R2,
      sample_ratios["Sample_Total_Average"]
    );
    console.log(JSON.stringify(finalConcentrations), "finalConcentrations");
    const nonZeroConcentrationValues = this.filterEmptyStrings(
      finalConcentrations
    );
    console.log(
      JSON.stringify(nonZeroConcentrationValues),
      "nonZeroConcentrationValues"
    );
    const finalConcentrationAvg = this.averageObjectValues(
      nonZeroConcentrationValues
    );
    console.log(finalConcentrationAvg, "finalConcentrationAvg");
    finalConcentrations = {
      ...finalConcentrations,
      R1,
      R2,
      Sample_Ratio: sample_ratios["Sample_Total_Average"],
      "Final Concentration Avg": finalConcentrationAvg,
    };
    Object.keys(finalConcentrations).forEach((concentration_label) => {
      outputHeadersAsStrings.unshift(concentration_label);
    });
    outputHeadersAsStrings.forEach((header) => {
      outputHeadersAsObjects.push({ label: header, key: header });
    });
    let objectStore = db
      .transaction(["dataBuffer"], "readwrite")
      .objectStore("dataBuffer");
    let req2 = objectStore.getAll();
    req2.onerror = (e) => {
      console.log(e);
    };
    req2.onsuccess = (e) => {
      const cloudData = [finalConcentrations]
        .concat([combined_ratios])
        .concat(combined_meta_data);
      this.saveToCloud(cloudData, outputHeadersAsStrings);
      output_data = combined_meta_data.concat(e.target.result);
      output_data = [combined_ratios].concat(output_data);
      output_data = [finalConcentrations].concat(output_data);
      this.setState({
        error_message: "Test Completed",
        save_ready: true,
        preparing_save: false,
        finalFinalConcentration: finalConcentrationAvg,
      });
    };
  };

  saveToCloud = async (cloudData, headers) => {
    const csvContent = convertToCSV(cloudData, headers);
    const fileName = `${this.generateFileName()}.csv`;

    try {
      const result = await saveCSVToCloud(fileName, csvContent);
      console.log("CSV saved to cloud:", result);
      return result;
    } catch (error) {
      console.error("Error saving CSV to cloud:", error);
      throw error;
    }
  };

  generateFileName = () => {
    return (
      this.state.device_name +
      "_" +
      [
        new Date().getDate(),
        new Date().getMonth() + 1,
        new Date().getFullYear(),
      ].join("-") +
      "_" +
      [
        new Date().getHours(),
        new Date().getMinutes(),
        new Date().getSeconds(),
      ].join("-")
    );
  };

  handle_load_control_file = (data) => {
    this.setState({ controlFileUploaded: data });
  };

  extractConcentrationParameters = (data) => {
    let concentrationParameterNames = [
      "A1",
      "B1",
      "N1",
      "A2",
      "B2",
      "N2",
      "A3",
      "B3",
      "N3",
      "K01",
      "S01",
      "Smax1",
      "eN1",
      "K02",
      "S02",
      "Smax2",
      "eN2",
      "K03",
      "S03",
      "Smax3",
      "eN3",
    ];
    let headers = data[0];
    let firstRow = data[1]; // only the first row of data

    concentrationParameterNames.forEach((header) => {
      let index = headers.indexOf(header);
      if (index !== -1) {
        concentrationParameters[header] = parseFloat(firstRow[index]);
      }
    });
  };

  handle_load_sample_file = (data) => {
    googleSheetID =
      data[0][data[0].indexOf("sheetID")] ||
      "1_PwS8fDXb6E335_yzQjXuj2Q8OE2PbdOj4ELTm3uBj0";
    baseCurrentMax =
      parseFloat(data[0][data[0].indexOf("max base current")]) || Infinity;
    this.extractConcentrationParameters(data);
    this.setState({ sampleFileUploaded: data });
  };

  currentlyRunningControlTest = () => {
    return (
      this.state.controlFileUploaded !== undefined && !this.runningControlTest
    );
  };

  prepare_start_run_test = () => {
    this.setState({
      menu_open: false,
      show_error: true,
      error_message: "Add buffer solution to the cartridge",
    });
  };

  start_run_test = () => {
    const data = this.currentlyRunningControlTest()
      ? this.state.controlFileUploaded
      : this.state.sampleFileUploaded;
    this.setState(
      {
        runningControlTest: this.currentlyRunningControlTest(),
        menu_open: false,
        loading: true,
        loading_file: false,
        automated_test: true,
        show_error: "",
        error_message: "",
      },
      () => {
        let headers = data[0];
        let tempData = [];
        for (let i = 1; i < data.length; i++) {
          let tempRow = {};
          headers.forEach((val, index) => {
            tempRow[val] = data[i][index];
          });
          tempData.push(tempRow);
        }
        let pre_curve_count = headers.length - 1;
        let curves = [];
        for (let i = 0; i <= pre_curve_count; i++) {
          curves.push(i);
        }

        if (this.state.automated_test) {
          tempData.sort(function(a, b) {
            return a.Order - b.Order;
          });
          automation_configs = tempData;
          this.run_automated_tests(tempData);
        } else {
          this.props.updateGraphMethod(tempData, curves);
          this.setState({ loading: false, dataBuffer: tempData });
        }
      }
    );
  };

  run_automated_tests = async (test_configs) => {
    if (test_configs.length == 0 && !this.state.runningControlTest) {
      console.log("==== Prepare save ====");
      if (ranSaturatedTest) {
        this.prepare_export();
      }
      this.setState({
        show_error: true,
        automated_test: false,
        error_message:
          "Discard the patient sample, add saturation sample to the cartridge",
        firstRunOfAutomation: true,
        calculateControlRatio: false,
      });
    } else if (test_configs.length == 0 && this.state.runningControlTest) {
      this.prepare_save_control();
    } else {
      let row = test_configs[0];
      if (
        typeof row.Freq === "undefined" ||
        typeof row.FreqNR === "undefined" ||
        typeof row["Start Volt"] === "undefined" ||
        typeof row.Range === "undefined" ||
        typeof row.RangeNR === "undefined" ||
        typeof row["WE Select"] === "undefined" ||
        row.Freq == "" ||
        row.FreqNR == "" ||
        row["Start Volt"] == "" ||
        row.Range == "" ||
        row.RangeNR == "" ||
        row["WE Select"] == ""
      ) {
        automation_configs.shift();
        this.run_automated_tests(automation_configs);
      } else {
        if (this.state.debug) console.log(row);

        let swv = 3;
        if (typeof row["SWVs"] === "undefined" || row["SWVs"] == "") {
          try {
            let SWV_characteristic = await this.state.current_service.getCharacteristic(
              "16d30bce-f148-49bd-b127-8042df63ded0"
            );
            let val = await SWV_characteristic.readValue();
            swv = val.getUint8();
          } catch (e) {
            console.log(e, ": failed capturing SWV");
            alert("Failed to capture SWV");
            swv = "";
          }
        } else {
          swv = parseInt(row["SWVs"]);
        }

        let EquationType = 1;
        if (typeof row["Equation"] !== "undefined" && row["Equation"] != "") {
          // eslint-disable-next-line default-case
          switch (row["Equation"].toLowerCase()) {
            case "equation 1":
            case "linear":
            case "1":
              EquationType = 1;
              break;
            case "equation 2":
            case "hyperbolic":
            case "2":
              EquationType = 2;
              break;
            case "equation 3":
            case "exponential":
            case "3":
              EquationType = 3;
              break;
          }
        } else if (this.state.firstRunOfAutomation) {
          alert(
            "Failed to capture equation type in automated test specifications. Test will still run with default values."
          );
        }

        let sweepDirection = 0;
        if (
          typeof row["Sweep Direction"] !== "undefined" &&
          row["Sweep Direction"] != ""
        ) {
          sweepDirection = parseInt(row["Sweep Direction"]);
        } else if (this.state.firstRunOfAutomation) {
          alert(
            "Failed to capture Sweep Direction value in automated test specifications. Test will still run with default values."
          );
        }

        this.setState({
          firstRunOfAutomation: false,
          frequency: row.Freq,
          frequency_NR: row.FreqNR,
          start_voltage: parseFloat(row["Start Volt"]),
          range: row.Range,
          range_NR: row.RangeNR,
          SWV: swv,
          we_selected: parseInt(row["WE Select"]),
          selectedEquation: concentrationEquationOptions[EquationType - 1],
          selectedSweepDirection: sweepDirectionOptions[sweepDirection],
        });
        this.updateCharacteristics(true);
      }
    }
  };

  updateBattery = () => {
    if (this.state.current_service) {
      this.state.current_service
        .getCharacteristic("16d30bca-f148-49bd-b127-8042df63ded0")
        .then((characteristic) => {
          characteristic.readValue().then((value) => {
            this.setState({ battery_level: value.getInt8() });
          });
        })
        .catch((error) => {
          console.log("Battery Characteristic Read", error);
        });
    }
  };

  changeEquation = (selectedEquation) => {
    this.setState({ selectedEquation });
  };

  changeSweepDirection = (selectedSweepDirection) => {
    this.setState({ selectedSweepDirection });
  };

  render() {
    return (
      <div
        style={{
          zIndex: 1,
          position: "absolute",
          width: "20vw",
          height: "100vh",
          right: 0,
        }}
      >
        {this.state.show_error && (
          <div className="popup">
            <div style={{ fontSize: 26, textAlign: "center", width: "100%" }}>
              {this.state.error_message}
            </div>
            {this.state.error_message ==
              "Add buffer solution to the cartridge" && (
              <div
                className="button start-test"
                style={{ height: 26 }}
                onClick={this.start_run_test}
              >
                Start
              </div>
            )}
            {this.state.error_message ==
              "Discard the buffer solution, add patient sample to the cartridge" && (
              <div
                className="button start-test"
                style={{ height: 26 }}
                onClick={this.continueSampleTest}
              >
                Continue
              </div>
            )}
            {this.state.error_message == "Device Disconnected" && (
              <div
                className="button start-test"
                style={{ height: 26 }}
                onClick={this.pairDevice}
              >
                Pair device
              </div>
            )}

            {this.state.error_message == "Test Completed" &&
              this.state.save_ready && (
                <>
                  <h2 style={{ width: "100%", textAlign: "center" }}>
                    The sample free vancomycin concentration is :{" "}
                    {this.state.finalFinalConcentration + "mg/L"}
                  </h2>
                  <CSVLink
                    onClick={this.exportedData}
                    data={output_data}
                    style={{ textDecoration: "none", height: 30 }}
                    filename={this.generateFileName() + ".csv"}
                    className="button start-test"
                    headers={outputHeadersAsObjects}
                  >
                    Save
                  </CSVLink>
                </>
              )}
            {this.state.error_message ==
              "Discard the patient sample, add saturation sample to the cartridge" &&
              !this.state.save_ready && (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    className="button start-test"
                    style={{ height: 26 }}
                    onClick={this.prepare_export}
                  >
                    Complete Test
                  </div>
                  <span
                    style={{ fontSize: "2rem", margin: "15px 15px 0 15px" }}
                  >
                    or
                  </span>
                  <div
                    className="button start-test"
                    style={{ height: 26 }}
                    onClick={this.runSaturatedTest}
                  >
                    Run Saturated Test
                  </div>
                </div>
              )}
          </div>
        )}
        {this.state.menu_open ? (
          <div>
            <img
              onClick={this.toggleMenuOpen}
              src={require("../../img/close.png")}
              alt="Settings"
              style={{
                zIndex: 2,
                top: 9,
                right: "6vw",
                width: 40,
                cursor: "pointer",
                position: "absolute",
              }}
            />
            {this.state.characteristics_menu_open ? (
              <div className="settings-popup">
                <label className="option">
                  Frequency 1
                  <div>
                    <input
                      onChange={(e) => this.handleInputParameterChange(e)}
                      value={this.state.frequency}
                      name="frequency"
                      type="number"
                      className="input-text small"
                    />
                    Hz
                  </div>
                </label>

                <label className="option">
                  Frequency 2
                  <div>
                    <input
                      onChange={(e) => this.handleInputParameterChange(e)}
                      value={this.state.frequency_NR}
                      name="frequency_NR"
                      type="number"
                      className="input-text small"
                    />
                    Hz
                  </div>
                </label>

                <label className="option">
                  Start Voltage
                  <div>
                    <input
                      onChange={(e) => this.handleInputParameterChange(e)}
                      value={this.state.start_voltage}
                      name="start_voltage"
                      type="number"
                      className="input-text small"
                    />
                    mV
                  </div>
                </label>

                <label className="option">
                  Range 1
                  <div>
                    <input
                      onChange={(e) => this.handleInputParameterChange(e)}
                      value={this.state.range}
                      name="range"
                      type="number"
                      className="input-text small"
                    />
                  </div>
                </label>

                <label className="option">
                  Range 2
                  <div>
                    <input
                      onChange={(e) => this.handleInputParameterChange(e)}
                      value={this.state.range_NR}
                      name="range_NR"
                      type="number"
                      className="input-text small"
                    />
                  </div>
                </label>

                <label className="option">
                  WE Selected
                  <div>
                    <input
                      onChange={(e) => this.handleInputParameterChange(e)}
                      value={this.state.we_selected}
                      name="we_selected"
                      type="number"
                      className="input-text small"
                    />
                  </div>
                </label>

                <label className="option">
                  SWVs
                  <div>
                    <input
                      onChange={(e) => this.handleInputParameterChange(e)}
                      value={this.state.SWV}
                      name="SWV"
                      type="number"
                      className="input-text small"
                    />
                  </div>
                </label>

                <label className="option">
                  Equation
                  <div>
                    <Select
                      value={this.state.selectedEquation}
                      onChange={this.changeEquation}
                      options={concentrationEquationOptions}
                    />
                  </div>
                </label>
                <label className="option">
                  Practical Limit of Detection
                  <div>
                    <input
                      onChange={(e) => this.handleInputParameterChange(e)}
                      value={this.state.concentration_avg_filter}
                      name="concentration_avg_filter"
                      type="number"
                      className="input-text small"
                    />
                  </div>
                </label>

                <label className="option">
                  Sweep Direction
                  <div>
                    <Select
                      value={this.state.selectedSweepDirection}
                      onChange={this.changeSweepDirection}
                      options={sweepDirectionOptions}
                    />
                  </div>
                </label>

                <div className="flex">
                  <div
                    className="button start-test"
                    onClick={() => {
                      this.updateCharacteristics(false);
                    }}
                  >
                    {" "}
                    Update{" "}
                  </div>
                </div>
              </div>
            ) : (
              <div className="settings-popup">
                {this.state.loading_file ? (
                  <>
                    <label>
                      <input
                        type="radio"
                        value="calibrated"
                        checked={this.state.selectCalibrated === "calibrated"}
                        onChange={(val) => {
                          this.setState({ selectCalibrated: val.target.value });
                        }}
                      />
                      Cal-R (Calibration Required)
                    </label>
                    <label>
                      <input
                        type="radio"
                        value="non-calibrated"
                        checked={
                          this.state.selectCalibrated === "non-calibrated"
                        }
                        onChange={(val) => {
                          this.setState({ selectCalibrated: val.target.value });
                        }}
                      />
                      Cal-F (Calibration-Free)
                    </label>
                    {this.state.selectCalibrated && (
                      <>
                        {this.state.selectCalibrated === "calibrated" && (
                          <CSVReader
                            cssClass="load-csv"
                            label={`Control csv file ${
                              this.state.controlFileUploaded ? "✅" : "❌"
                            }`}
                            onFileLoaded={this.handle_load_control_file}
                          ></CSVReader>
                        )}
                        <CSVReader
                          cssClass="load-csv"
                          label={`Sample csv file ${
                            this.state.sampleFileUploaded ? "✅" : "❌"
                          }`}
                          onFileLoaded={this.handle_load_sample_file}
                        ></CSVReader>
                        {((this.state.selectCalibrated === "calibrated" &&
                          this.state.controlFileUploaded &&
                          this.state.sampleFileUploaded) ||
                          (this.state.selectCalibrated === "non-calibrated" &&
                            this.state.sampleFileUploaded)) && (
                          <div className="flex">
                            <div
                              style={{ textAlign: "center" }}
                              className="button start-test"
                              onClick={this.prepare_start_run_test}
                            >
                              Run
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </>
                ) : (
                  <div>
                    {this.state.loading && (
                      <div className="flex">
                        <div
                          className="button start-test"
                          onClick={this.stop_automated_test}
                        >
                          Stop Automated Test
                        </div>
                      </div>
                    )}

                    <div className="flex">
                      <div
                        className="button start-test"
                        onClick={this.prepare_emergency_save}
                      >
                        Prepare Save
                      </div>
                    </div>

                    <div className="flex">
                      <div
                        className="button start-test"
                        onClick={this.disconnectDevice}
                      >
                        Disconnect Device
                      </div>
                    </div>

                    {!this.state.loading && (
                      <div className="flex">
                        <div
                          className="button start-test"
                          onClick={this.open_loading_file}
                        >
                          Load Method
                        </div>
                      </div>
                    )}
                    {!this.state.loading && (
                      <div className="flex">
                        <div
                          className="button start-test"
                          onClick={this.open_characteristics_menu}
                        >
                          Edit Method
                        </div>
                      </div>
                    )}

                    <div className="flex">
                      <div
                        className="button start-test"
                        onClick={this.pairDevice}
                      >
                        Pair Device
                      </div>
                    </div>

                    <div className="flex">
                      <div
                        className="button start-test"
                        onClick={this.start_run_test}
                      >
                        Run
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        ) : (
          //End is menu open?
          <div>
            {this.state.device_paired == null ? (
              <div>
                {this.state.loading ? (
                  <div style={{ marginTop: 20, marginLeft: -27 }}>
                    <Loader
                      type="TailSpin"
                      color="#7dbcd2"
                      height={68}
                      width={68}
                    />
                    Pairing...
                  </div>
                ) : (
                  <div
                    className="flex"
                    style={{ position: "absolute", height: "100vh", right: 50 }}
                  >
                    <div
                      className="pair-device-button"
                      onClick={this.pairDevice}
                    >
                      Pair Device
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div>
                {this.state.loading ? (
                  <div>
                    <br></br>
                    <br></br>
                    <div style={{ marginTop: -20, marginLeft: -27 }}>
                      <Loader
                        type="TailSpin"
                        color="#7dbcd2"
                        height={68}
                        width={68}
                      />
                    </div>
                    <img
                      onClick={this.toggleMenuOpen}
                      src={require("../../img/settings.png")}
                      alt="Settings"
                      onMouseOver={(e) =>
                        (e.currentTarget.src = require("../../img/settings_highlighted.png"))
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.src = require("../../img/settings.png"))
                      }
                      style={{
                        cursor: "pointer",
                        top: 10,
                        right: "6vw",
                        position: "absolute",
                      }}
                    />
                    <br></br>
                    <br></br>

                    <div id="status-message" className="status-message">
                      {this.state.status_message}
                    </div>
                  </div>
                ) : (
                  <div>
                    <img
                      onClick={this.runTest}
                      src={require("../../img/play_button.png")}
                      alt="Settings"
                      onMouseOver={(e) =>
                        (e.currentTarget.src = require("../../img/play_button_highlighted.png"))
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.src = require("../../img/play_button.png"))
                      }
                      style={{
                        cursor: "pointer",
                        top: 10,
                        right: "calc(6vw + 80px)",
                        position: "absolute",
                      }}
                    />

                    <img
                      onClick={this.toggleMenuOpen}
                      src={require("../../img/settings.png")}
                      alt="Settings"
                      onMouseOver={(e) =>
                        (e.currentTarget.src = require("../../img/settings_highlighted.png"))
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.src = require("../../img/settings.png"))
                      }
                      style={{
                        cursor: "pointer",
                        top: 10,
                        right: "6vw",
                        position: "absolute",
                      }}
                    />

                    <div className="device-message">
                      Connected to: {this.state.device_name} (v
                      {this.state.firmware})
                    </div>

                    <div style={{ marginTop: 10 }}>
                      log output
                      <input
                        name="debug"
                        type="checkbox"
                        checked={this.state.debug}
                        onChange={(e) => this.handleInputParameterChange(e)}
                      />
                    </div>
                    <div
                      onClick={this.updateBattery}
                      className="no-highlight device-message"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: 0,
                      }}
                    >
                      Battery: {this.state.battery_level}%
                      <img
                        src={Refresh}
                        style={{ width: 30, marginLeft: 5 }}
                        alt="Update Battery"
                      />
                    </div>

                    <div id="status-message" className="status-message">
                      {this.state.status_message}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default SettingsMenu;
//© 2026, Aptayo. All rights reserved
